import { BarekamIcon, IconVariants } from "../icon/barekam-icon";
import React from "react";
import { WarehouseContainer, WarehouseContainerSelected } from "../../orders/order-popup/country-selector/styled";
import BarekamText from "../text";
import { WarehouseModel } from "../../shared/models/order/warehouse.model";
import { CountryModel } from "../../shared/models/countryModel";
import Message from "../message";
import { MessageSections } from "../message/message";
import BarekamChip from "../chip/barekamChip";
import { useAppSelector } from "../../../redux/store";
import { CurrencyModel } from "../../../redux/reducers/static-data.reducers";

export const SingleWarehouse = ({ warehouse, country, onChange, size, selected }: SingleWarehouseProps) => {
    const { languageId } = useAppSelector(state => state.messagesReducer);
    const { currencies } = useAppSelector(state => state.staticDataReducer);

    if (selected) {
        return (
            <WarehouseContainerSelected>
                <BarekamIcon variant={IconVariants.flag} country={country.abbreviation.toLowerCase()} />

                {size === 'm'
                    ? <BarekamText variant={'m'}>
                        {country.name[languageId]}
                        (<Message messageKey={country.abbreviation} sectionId={MessageSections.MAIN} />)
                    </BarekamText>
                    : ''
                }
            </WarehouseContainerSelected>
        )
    } else {
        return (
            <WarehouseContainer onClick={() => country.hasActiveWarehouse && onChange(warehouse, country, currencies)}>
                <BarekamIcon variant={IconVariants.flag} country={country.abbreviation.toLowerCase()} />

                {size === 'm'
                    ?
                    <div style={{ display: 'flex', gap: '0.25rem', height: '1.2rem', alignItems: 'center' }}>
                        <BarekamText variant={'m'} opaque={!country.hasActiveWarehouse}>
                            {country.name[languageId]}
                            (<Message messageKey={country.abbreviation} sectionId={MessageSections.MAIN} />)
                        </BarekamText>

                        {country.hasActiveWarehouse
                            ? ''
                            : <BarekamChip messageKey={'coming_soon'} statusId={4} chipSize={'s'} />}
                    </div>
                    : ''
                }
            </WarehouseContainer>
        )
    }
}

interface SingleWarehouseProps {
    warehouse: WarehouseModel,
    country: CountryModel,
    onChange: (warehouse: WarehouseModel, country: CountryModel, currencies: CurrencyModel[]) => void,
    size: 's' | 'm'
    selected?: boolean
}
